export default __webpack_public_path__ + "static/1930_1940-b3b311c02acea5dca820eedec0d3c6a6.jpg";